import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommmonService } from 'src/app/utils/common.service';
import { RequestsService } from '../services/requests.service';
import { Plans } from 'src/app/home/models/plans.interface';
import { EmployeeService } from '../services/employee.service';
import { Plan } from '../models/employee.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    private router: Router,
    private commonService: CommmonService,
    private requestService: RequestsService,
    private employeeService: EmployeeService,
    private route: ActivatedRoute,
  ) {}
  objetoLocalStorage: any;
  PlanUser: any;
  plans!: Plans[];
  imgPlanUser!: any;
  planData!: Plan;

  async ngOnInit(): Promise<void> {
    this.clearEmployeeData();
    this.setEmployeeData();
    this.setPlanUser();
    this.setPlanImages();
    this.getBannerPlan();
  }

  async getBannerPlan(): Promise<void> {
    try {
      this.planData = await this.employeeService.get_employee_plan();
      
    } catch (error) {
      console.error('Error al obtener el plan del usuario', error);
    }
  }

  private clearEmployeeData(): void {
    this.commonService.removeItemLocalStorage('getEmployee');
  }

  private setEmployeeData(): void {
    const employee = this.route.snapshot.data['resolverEmployee'];
    localStorage.setItem('getEmployee', JSON.stringify(employee));
    this.requestService.setEmployee(employee);
  }

  private setPlanUser(): void {
    const employeeData = localStorage.getItem('getEmployee');
    if (employeeData) {
      this.objetoLocalStorage = JSON.parse(employeeData);
      this.PlanUser = this.objetoLocalStorage.descripcion_plan;
    } else {
      this.objetoLocalStorage = null;
    }
  }

  private setPlanImages(): void {
    const plansData = localStorage.getItem('plans');
    if (plansData) {
      const data: Plans[] = JSON.parse(plansData);
      const selectedPlan = data.find(
        (plan) => plan.titleplan === this.PlanUser,
      );
      if (selectedPlan) {
        this.imgPlanUser = selectedPlan.imageplan;
      }
    }
  }

  goToPlan() {
    this.router.navigate(['/plans']);
  }
}
